import { v4 as uuidv4 } from "uuid";
import React, { useEffect, useState } from "react";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { ReactComponent as CloseIcon } from "../../../../../../assets/img/svg/CloseIcon.svg";
import { ReactComponent as ActiveControl } from "../../../../../../assets/img/svg/ActiveControl.svg";
import { ReactComponent as InactiveControl } from "../../../../../../assets/img/svg/InactiveControl.svg";
import CustomDatePickerV2 from "../../../common/commonComponents/CustomDatePicker-V2";
import moment from "moment";
import { DesktopTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import AAutoComplete from "../../../common/form-fields-mui/AAutoComplete";
import {
  DUPLICATE_LECTURE_ERROR_MESSAGE,
  checkDuplicateLecture,
  getDuplicateErrorMessage,
  maxDate31Days,
  uuidValidateV4,
  demoClassLanguageDropdown,
  isLecturePassed,
} from "../helper";
import AButton from "../../../common/form-fields-mui/AButton";
import { saveLectureValidator, subjectDropdown } from "./EditLectureForm";
import { useFetchSubjectLectureDropdown } from "../hooks";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import SelectLecturePopover from "./selectLecture/SelectLecturePopover";
import { findHighestMissingLectureNumber } from "../../lecture/helper";
import MultiBatchLectureAccordion from "./MultiBatchLectureAccordion";

export const classTypeDropdown = [
  {
    value: "LECTURE",
    label: "Lecture",
  },
  {
    label: "Doubt class",
    value: "DOUBT CLASS",
  },
  {
    label: "Extra Class",
    value: "EXTRA CLASS",
  },
  {
    label: "Demo class",
    value: "DEMO CLASS",
  },
];
export const timepickerStyle = {
  "& .MuiInputBase-root": {
    height: "40px",
    // borderRadius: '8px'
  },
  "& .MuiInputBase-input": {
    padding: "7px 8px",
    fontSize: "12px",
  },
  "& .MuiInputAdornment-root": {
    display: "none",
  },
};

const resetFormFields = {
  date: "",
  startTime: "",
  endTime: "",
  classType: "",
  subject: "",
  faculty: "",
  lecture: "",
  room: "",
  breakoutBatchList: [],
};

export const getSubjectFaculty = (
  selectedFaculty,
  facultyDropdown,
  subject
) => {
  const selectedFacultyParsed = selectedFaculty
    ? JSON.parse(selectedFaculty)
    : "";
  if (!selectedFacultyParsed || !subject) return "";
  const facultyId = selectedFacultyParsed[subject];
  if (!facultyId) return "";
  const facultyList = facultyDropdown?.filter(
    (item) => item?.value === facultyId
  );

  return (facultyList || []).length > 0 ? facultyList[0] : "";
};

export const getClassTypeObj = (formType) => {
  const normalizedType = formType?.toLowerCase();
  return (
    classTypeDropdown.find(
      (item) => item.label.toLowerCase() === normalizedType
    ) || classTypeDropdown[0]
  );
};
const AddLectureModalForm = ({
  isOpen,
  onClose,
  batchDetails,
  planSubjects,
  roomsDropdown,
  subjectFacultyDropdown,
  formData,
  setLectures,
  openMode,
  setIsNeedToPublish,
  isEnabledMsTeamsSync,
  lectures,
  saveOnEdit = () => {},
  formType,
  selectedFaculty,
  updateLectures,
  ...props
}) => {
  const isICONbatch = batchDetails.academicCareer.dispValue === "ICON";
  const isADBatch = batchDetails.businessArea.dispValue === "IC006";
  const isAdLectureOngoing =
    isADBatch && isLecturePassed(formData.lectureStartTime);

  const FormField = {
    date: formData?.date || "",
    startTime: formData?.startTime || "",
    endTime: formData?.endTime || "",
    classType: "",
    subject: "",
    faculty: formData?.faculty || "",
    lecture: "",
    room: formData?.room || "",
    breakoutBatchList: formData?.breakoutBatchList || [],
  };

  const subjectsDropdown = subjectDropdown(planSubjects);

  const [toggleState, setToggleState] = useState(
    formData?.isMSteams
      ? formData?.isMSteams
      : formData?.msTeam
      ? formData?.msTeam.value === "Yes"
      : isEnabledMsTeamsSync
  );

  const [form, setForm] = useState({
    ...FormField,
    classType: getClassTypeObj(formType),
  });
  const [isDateTimeEdited, setIsDateTimeEdited] = useState(false);
  const [isDisabledMsId, setDisabledMsId] = useState(false);
  const [isDisabledOther, setDisabledOther] = useState(false);

  const lecturesDropdown = useFetchSubjectLectureDropdown(
    formData?.plan?.value,
    formData?.duration?.value || formData?.duration,
    form?.subject?.label
  );

  const isDemoClass = form?.classType?.value === "DEMO CLASS";

  useEffect(() => {
    if (formData?.msTeam) setToggleState(formData?.msTeam?.value === "Yes");
  }, [formData?.msTeam]);

  useEffect(() => {
    if (formData.subject) {
      const prefilledSubject = subjectsDropdown.filter(
        (item) => item.label.toLowerCase() === formData.subject.toLowerCase()
      )[0];

      setTimeout(() => {
        // setForm((prev) => ({ ...prev, subject: prefilledSubject }));
        formHandler(prefilledSubject, "subject");
      }, 1500);
    }
  }, [formData.subject]);

  useEffect(() => {
    if (formData.lecture || formData.lectureId) {
      const prefilledLecture = lecturesDropdown.filter(
        (item) =>
          item.value === formData.lecture || item.value === formData.lectureId
      )[0];

      if (prefilledLecture) {
        setForm({
          ...form,
          lecture: prefilledLecture,

          room: formData.room,
          faculty: formData.faculty || {
            value: formData.facultyId,
            name: formData.facultyName,
            label: formData.facultyName,
          },
        });
      }
    } else if (lecturesDropdown.length) {
      // if only one active lecture OR Lecture-1 is not selected
      if (lecturesDropdown.length === 1) {
        setTimeout(() => {
          setForm({
            ...form,
            lecture: lecturesDropdown[0],
          });
        }, 3000);

        return;
      }

      // if Lecture-1 already taken, prefill highestActiveLecture
      const missingLecture = findHighestMissingLectureNumber({
        selectedSubject: form?.subject.label,
        lecturesArray: lectures,
        availableLectures: lecturesDropdown,
      });

      setForm({
        ...form,
        lecture: missingLecture,
      });
    }
  }, [formData.lectureId, lecturesDropdown]);

  useEffect(() => {
    setForm({ ...FormField, classType: getClassTypeObj(formType) });
  }, [isOpen]);

  const formHandler = (value, key) => {
    //todo: check

    if (openMode === "EDIT" && !formData.isNew) {
      if (key === "msTeam") {
        let last2Hour = moment(formData?.lectureStartTime).subtract(
          120,
          "minutes"
        );
        if (new Date(last2Hour) < new Date()) {
          // return failureToast("MS Teams status cannot be changed 2 hours before the lecture start time")
        }
        setDisabledOther(true);
      } else {
        setDisabledMsId(true);
      }
    }

    if (key === "subject") {
      setForm((prev) => ({ ...prev, [key]: value }));
      setForm((prev) => ({ ...prev, ["lecture"]: "" }));
      setForm((prev) => ({
        ...prev,
        ["faculty"]: getSubjectFaculty(
          selectedFaculty,
          subjectFacultyDropdown[value?.label],
          value?.label
        ),
      }));
    } else {
      setForm((prev) => ({ ...prev, [key]: value }));
    }
  };

  const getLectureRequest = (id) => {
    return {
      ...form,
      timeTableClassType: form?.classType?.value,
      classType: form?.classType?.value,
      subject: form?.subject?.label,
      roomName: form?.room?.label,
      roomId: form?.room?.value,
      lectureId: form?.lecture?.value,
      lectureName: form?.lecture?.lectureName || form?.lecture?.label,
      lectureCode: form?.lecture?.lectureCode,
      facultyName: form?.faculty?.label,
      facultyId: form?.faculty?.value,
      msTeam: {
        value: toggleState || formData?.isMSteams ? "Yes" : "No",
        label: toggleState || formData?.isMSteams ? "Yes" : "No",
      },
      isEdit: false,
      isNew: true,
      id: id || uuidv4(),
      isTimeTableEvent: true,
      status: "ACTIVE",
    };
  };

  const editLecture = () => {
    const editedRow = lectures[formData?.selectedIndex];

    updateLectures(
      formData?.selectedIndex,
      {
        ...editedRow,
        ...form,

        timeTableClassType: form?.classType?.value,
        classType: form?.classType?.value,
        subject: form?.subject?.label,
        roomName: form?.room?.label,
        roomId: form?.room?.value,
        lectureId: form?.lecture?.value,
        lectureName: form?.lecture?.lectureName || form?.lecture?.label,
        lectureCode: form?.lecture?.lectureCode,
        facultyName: form?.faculty?.label,
        facultyId: form?.faculty?.value,
        msTeam: {
          value: toggleState || formData?.isMSteams ? "Yes" : "No",
          label: toggleState || formData?.isMSteams ? "Yes" : "No",
        },
        isItemEdited: true,
        isEdit: false,
        ...missingLectureField(editedRow),
      },
      true
    );

    if (openMode === "EDIT") {
      setIsNeedToPublish(true);
    }
    onCloseReset();
  };

  const missingLectureField = (lecture) => {
    if (!lecture?.isMissingLecture) return {};
    return {
      isMissingLecture: false,
      status: "ACTIVE",
    };
  };

  const editPublishedEvents = (selectedIndex = -1, id) => {
    const lecture = getLectureRequest(id);
    const tempLectures = [...lectures];
    tempLectures[selectedIndex] = {
      ...lecture,
      id,
    };
    setLectures(tempLectures);
    if (id)
      saveOnEdit(
        [{ ...lecture, id, isItemEdited: true }],
        true,
        false,
        undefined,
        []
      );
    onCloseReset();
  };

  const saveEvent = () => {
    if (!saveLectureValidator(form)) return false;
    if (form?.room === "") {
      failureToast("Please select a room");
      return;
    }

    if (
      formData?.selectedIndex &&
      (formData?.selectedIndex !== -1 || uuidValidateV4(formData?.id))
    ) {
      // if event made via calendar-> modify lectures array and not call API
      editLecture();
      return;
    } else if (formData?.id && !uuidValidateV4(formData?.id)) {
      //if event is already published & modified -> call API
      editPublishedEvents(formData.selectedIndex, formData.id);
      return;
    }

    const duplicateItem = checkDuplicateLecture(
      lectures,
      form,
      formData?.selectedIndex || -1
    );

    if (duplicateItem) {
      failureToast(getDuplicateErrorMessage(duplicateItem?.classType));
      return;
    }

    let lecture = getLectureRequest();
    setLectures((lectures) => [...lectures, lecture]);

    if (openMode === "EDIT") {
      setIsNeedToPublish(true);
    }
    onCloseReset();
  };

  const editHandler = () => {
    if (!saveLectureValidator(form)) return;

    if (isLecturePassed(formData?.lectureStartTime) && isDateTimeEdited)
      return failureToast(
        "Lecture has already started. Date and Time cannot be modified."
      );

    if (isLecturePassed(formData.lectureEndTime)) {
      return failureToast("Lecture has ended. Cannot save the changes.");
    }

    const editedRow = lectures[formData?.selectedIndex];
    updateLectures(
      formData?.selectedIndex,
      {
        ...editedRow,
        ...form,
        classType: form?.classType?.value,
        subject: form?.subject?.label,
        roomName: form?.room?.label,
        roomId: form?.room?.value,
        lectureId: form?.lecture?.value,
        lectureName: form?.lecture?.lectureName || form?.lecture?.label,
        facultyName: form?.faculty?.label,
        facultyId: form?.faculty?.value,
        msTeam: {
          value: toggleState ? "Yes" : "No",
          label: toggleState ? "Yes" : "No",
        },
        eventJoinUrl: form?.eventJoinUrl,
        isEdit: false,
        lectureCode: form?.lecture?.lectureCode || form?.lectureCode,
        lectureStartTime: moment(
          `${moment(form.date).format("DD-MM-YYYY")} ${form.startTime}`,
          "DD-MM-YYYY hh:mm"
        ).format(),
        lectureEndTime: moment(
          `${moment(form.date).format("DD-MM-YYYY")} ${form.endTime}`,
          "DD-MM-YYYY hh:mm"
        ).format(),
        isItemEdited: true,
        ...missingLectureField(editedRow),
      },
      true
    );

    onCloseReset();
  };

  const onCloseReset = () => {
    onClose();
    setForm(resetFormFields);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Modal
        size="lg"
        isOpen={isOpen}
        toggle={onCloseReset}
        style={{ width: "600px" }}
      >
        <ModalBody>
          <div className="d-flex justify-content-between align-items-start mb-4">
            <div className="heading-4 label-color text-bold">
              {formData.classType ? "Edit" : "Add"}{" "}
              {form?.classType?.value?.toLowerCase()}
            </div>
            <CloseIcon onClick={() => onCloseReset()} />
          </div>
          <div className="regular-large-bold color-dark mb-4">
            Batch: {batchDetails?.batchName}
          </div>
          <Row className="mb-2">
            <Col sm="4">
              <div className="d-flex flex-column">
                <div className="regular-large-bold color-dark mb-2">Date</div>
                <CustomDatePickerV2
                  placeHolder="Date"
                  value={form?.date}
                  minDate={moment()}
                  handler={(index, date) => {
                    formHandler(date, "date");
                    setIsDateTimeEdited(true);
                  }}
                  height="32px"
                  maxDate={maxDate31Days()}
                  disabled={isDisabledOther || isAdLectureOngoing}
                />
              </div>
            </Col>
            <Col sm="4">
              <div className="d-flex flex-column">
                <div className="regular-large-bold color-dark mb-2">
                  Start time
                </div>
                <DesktopTimePicker
                  ampm={false}
                  value={
                    form?.startTime ? moment(form?.startTime, "HH:mm") : null
                  }
                  onChange={(value) => {
                    formHandler(moment(value)?.format("HH:mm"), "startTime");
                    setIsDateTimeEdited(true);
                  }}
                  sx={timepickerStyle}
                  disabled={isDisabledOther || isAdLectureOngoing}
                />
              </div>
            </Col>
            <Col sm="4">
              <div className="d-flex flex-column">
                <div className="regular-large-bold color-dark mb-2">
                  End time
                </div>
                <DesktopTimePicker
                  ampm={false}
                  value={form?.endTime ? moment(form?.endTime, "HH:mm") : null}
                  onChange={(value) => {
                    formHandler(moment(value)?.format("HH:mm"), "endTime");
                    setIsDateTimeEdited(true);
                  }}
                  sx={timepickerStyle}
                  disabled={isDisabledOther || isAdLectureOngoing}
                />
              </div>
            </Col>
          </Row>
          <div className="mb-2 d-flex flex-column">
            <div className="mb-2 regular-large-bold color-dark">Class type</div>
            <AAutoComplete
              placeholder={"Select"}
              items={classTypeDropdown}
              currentValue={form?.classType}
              handleChange={(value) => formHandler(value, "classType")}
              isMulti={false}
              isDisabled={true}
              style={{ control: { height: "40px" } }}
            />
          </div>
          <div className="mb-2 d-flex flex-column">
            <div className="mb-2 regular-large-bold color-dark">Subject</div>
            <AAutoComplete
              placeholder={"Select"}
              items={subjectsDropdown}
              currentValue={form?.subject}
              handleChange={(value) => formHandler(value, "subject")}
              isMulti={false}
              style={{ control: { height: "40px" } }}
            />
          </div>
          <div className="mb-2 d-flex flex-column">
            <div className="mb-2 regular-large-bold color-dark">
              Lecture name
            </div>
            <SelectLecturePopover
              {...{
                editForm: form,
                lecturesDropdown,
                editFormHandler: formHandler,
              }}
            />

            {/* <AAutoComplete
              placeholder={"Select"}
              items={lecturesDropdown}
              currentValue={form?.lecture}
              handleChange={(value) => formHandler(value, "lecture")}
              isMulti={false}
              style={{ control: { height: "40px" } }}
            /> */}
          </div>
          <div className="mb-2 d-flex flex-column">
            <div className="mb-2 regular-large-bold color-dark">Faculty</div>
            <AAutoComplete
              placeholder={"Select"}
              items={subjectFacultyDropdown?.[form?.subject?.label]}
              currentValue={form?.faculty}
              handleChange={(value) => formHandler(value, "faculty")}
              isMulti={false}
              style={{ control: { height: "40px" } }}
              isDisabled={form?.subject === ""}
            />
          </div>
          <div className="mb-2 d-flex flex-column">
            <div className="mb-2 regular-large-bold color-dark">Room</div>
            <AAutoComplete
              placeholder={"Select"}
              items={roomsDropdown}
              currentValue={form?.room}
              handleChange={(value) => formHandler(value, "room")}
              isMulti={false}
              style={{ control: { height: "40px" } }}
            />
          </div>
          {isDemoClass && (
            <div className="mb-2 d-flex flex-column">
              <div className="mb-2 regular-large-bold color-dark">Language</div>
              <AAutoComplete
                placeholder={"Select"}
                items={demoClassLanguageDropdown}
                currentValue={form?.language}
                handleChange={(value) => formHandler(value, "language")}
                isMulti={false}
                style={{ control: { height: "40px" } }}
              />
            </div>
          )}
          {isEnabledMsTeamsSync && (
            <div className="d-flex align-items-center mb-4">
              <div className="regular-large-bold color-dark mr-3">
                MS teams/GC
              </div>
              {toggleState ? (
                <>
                  <ActiveControl
                    onClick={() => setToggleState(false)}
                    isDisabled={isDisabledMsId || isAdLectureOngoing}
                  />
                  <span className="ml-2">Yes</span>
                </>
              ) : (
                <>
                  <InactiveControl
                    onClick={() => setToggleState(true)}
                    isDisabled={isDisabledMsId || isAdLectureOngoing}
                  />
                  <span className="ml-2">No</span>
                </>
              )}
            </div>
          )}
          {props.isCarrierHYB && (
            <div className="mb-4">
              <div className="mb-2 regular-large-bold color-dark">
                Meeting link
              </div>
              <AInput
                placeHolder="Meeting Link"
                value={form?.eventJoinUrl}
                handler={(value) => formHandler(value, "eventJoinUrl")}
                style={{ height: "40px" }}
              />
            </div>
          )}
          {isICONbatch && batchDetails?.onlineBatchType && (
            <>
              <hr className="my-3" />
              <MultiBatchLectureAccordion
                academicPlanId={formData?.plan?.value}
                form={form}
                setForm={setForm}
                formData={formData}
                batchDetails={batchDetails}
              />
            </>
          )}

          <div>
            <AButton
              className="btn-left-0"
              variant="primary_filled"
              onClick={formData.isEdit ? editHandler : saveEvent}
            >
              Save event
            </AButton>
          </div>
        </ModalBody>
      </Modal>
    </LocalizationProvider>
  );
};

export default AddLectureModalForm;
